import { BASEURL, CLIENT_ID, CLIENT_SECRET } from "../configs/AppConfig";
import http from "../http-common";
const axios = require("axios").default;

class AuthService {
  login(username, password) {
    var config = {
      headers: {
        Authorization: "",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    return axios.post(
      BASEURL + "api/admin-login",
      {
        // grant_type      : "password",
        // client_id       : CLIENT_ID,
        // client_secret   : CLIENT_SECRET,
        username: username,
        password: password,
      },
      config
    );
  }

  getUser(token) {
    var config = {
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/json",
      },
    };
    return axios.get(BASEURL + "api/v1/backoffice/auth/user/current", config);
  }

  //Log Out
  logOut() {
    return http
      .get(`api/v1/logout`)
      .then((response) => {
        // Handle successful response
        console.log("Logout successful:", response);
        return response;
      })
      .catch((error) => {
        // Handle errors
        if (error.response) {
          // Server responded with a status other than 2xx
          console.error("Logout failed:", error.response.data);
          alert("Logout failed: " + error.response.data.message);
        } else if (error.request) {
          // Request was made but no response received
          console.error("No response received:", error.request);
          alert(
            "No response received from the server. Please try again later."
          );
        } else {
          // Something else caused the error
          console.error("Error:", error.message);
          alert("An error occurred: " + error.message);
        }
        return Promise.reject(error);
      });
  }
}

export default new AuthService();
